// Func = limiting Scope for this file
var lastScrollTop = 0;

//map array of click tags
var tagLocation = [];


var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;


(function () {
	// Menu
	let menuBlock = document.querySelector('.menu-block');
	let menuBtn = document.querySelector('.js-menu');
	let closeMenu = document.querySelector('.js-close');

	menuBtn.addEventListener('click', function (e) {
		e.preventDefault();
		$(menuBlock).css('display','flex').fadeIn();
	})
	closeMenu.addEventListener('click', function (e) {
		e.preventDefault();
		$(menuBlock).fadeOut();
	})

	// Booking
	let bookingBlock = document.querySelector('.booking-block');
	let bookBtn = document.querySelector('.js-booking');
	let closeBook = document.querySelector('.js-close-booking');

	

	closeBook.addEventListener('click', function (e) {
		e.preventDefault();
		$(bookingBlock).fadeOut();
	})

	//signup badge Functionality
	if(document.getElementById('signupBadge')){
		document.getElementById('signupBadge').addEventListener('click', function(){
			document.getElementById('signupContainer').classList.add('open')
		})
		document.getElementById('signupClose').addEventListener('click', function(){
			document.getElementById('signupContainer').classList.remove('open')
		})
	}


	if(document.getElementById('tourList')){
		const listContainer = document.getElementById('tourList');
		const blogID = listContainer.getAttribute('data-module');
		
		

		if(windowWidth < 600){
			loadTour(document.getElementById('tourFilter').value);
			document.getElementById('tourFilter').addEventListener('change', function(){
				loadTour(this.value)
			})
		} else {
			let activeFilter = document.getElementById('tourFilter').getElementsByTagName('li')[0].getAttribute('data-target');
			loadTour(activeFilter);

			let allTourFilter = document.getElementById('tourFilter').getElementsByTagName('li');
			for(let i = 0; i < allTourFilter.length; i ++){
				allTourFilter[i].addEventListener('click',function(){
					let currentTarget = this.getAttribute('data-target');
					for(let j =0; j < allTourFilter.length; j++){
						if(allTourFilter[j] == this){
							this.classList.add('active')
						} else {
							allTourFilter[j].classList.remove('active')
						}
					}
					loadTour(currentTarget);
				})
			}
		}

		
			
		function loadTour(tag){
			listContainer.classList.add('preloaded');
			fetch(`${site_url}ajax/functions.php?operation=tourLoop&selected=`+blogID+`&tag=`+ tag,{method: "GET"}) 
			.then((resp) => resp.json()) // Transform the data into json
			.then((data) => {
				listContainer.innerHTML = data.html; //set data response via fetch in the container
				listContainer.classList.remove('preloaded'); 
			});
		}
    	//polyfill
    	self.fetch||(self.fetch=function(e,n){return n=n||{},new Promise(function(t,s){var r=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(r.status/100|0),statusText:r.statusText,status:r.status,url:r.responseURL,text:function(){return Promise.resolve(r.responseText)},json:function(){return Promise.resolve(JSON.parse(r.responseText))},blob:function(){return Promise.resolve(new Blob([r.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var c in r.open(n.method||"get",e,!0),r.onload=function(){r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},r.onerror=s,r.withCredentials="include"==n.credentials,n.headers)r.setRequestHeader(c,n.headers[c]);r.send(n.body||null)})});
	}

	if(document.getElementById('pinsSelect')){
		document.getElementById('pinsSelect').addEventListener('change', function(){
			loadPins(this.value);
		})
		document.getElementsByClassName('js-reset')[0].addEventListener('click', function(){
			document.getElementById('pinsContainer').innerHTML = '';
			document.getElementById('pinsSelect').selectedIndex = 0;
		})

		function loadPins(tag){
			let pinsContainer = document.getElementById('pinsContainer');
			pinsContainer.classList.add('preloaded');
			let blogID = pinsContainer.getAttribute('data-blog');
			fetch(`${site_url}ajax/functions.php?operation=loadPins&selected=`+blogID+`&tag=`+ tag,{method: "GET"}) 
			.then((resp) => resp.json()) // Transform the data into json
			.then((data) => {
				pinsContainer.innerHTML = data.html; //set data response via fetch in the container
				pinsContainer.classList.remove('preloaded'); 
			});
		}
		//polyfill
    	self.fetch||(self.fetch=function(e,n){return n=n||{},new Promise(function(t,s){var r=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(r.status/100|0),statusText:r.statusText,status:r.status,url:r.responseURL,text:function(){return Promise.resolve(r.responseText)},json:function(){return Promise.resolve(JSON.parse(r.responseText))},blob:function(){return Promise.resolve(new Blob([r.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var c in r.open(n.method||"get",e,!0),r.onload=function(){r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},r.onerror=s,r.withCredentials="include"==n.credentials,n.headers)r.setRequestHeader(c,n.headers[c]);r.send(n.body||null)})});
	}


	if(document.getElementsByClassName('hover-items__mobile').length > 0){
		let allClicks = document.getElementsByClassName('js-item-tag')
		for(let i = 0 ; i < allClicks.length; i++){
			let clickTitle = allClicks[i].getElementsByTagName('h3')[0];
			clickTitle.addEventListener('click', function(){
				let copyHeight = this.nextElementSibling.clientHeight;
				if(this.parentElement.classList.contains('active')){
					this.parentElement.classList.remove('active');
					this.parentElement.style.height = '40px';
				} else {
					this.parentElement.classList.add('active');
					this.parentElement.style.height = (copyHeight + 40) + 'px';
				}
			});
		}
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});
		$(".arrow-left").click(function () {
			if($(this).context.parentNode.parentNode.classList.value.indexOf("adults")>-1){
				let val = numberGuest($("#adults").val(),false);
				$("#adults").val(val);
			}else{
				let val = numberGuest($("#children").val(),false);
				$("#children").val(val);
			}
		});

		$(".arrow-right").click(function () {
			if($(this).context.parentNode.parentNode.classList.value.indexOf("adults")>-1){
				let val = numberGuest($("#adults").val(),true);
				$("#adults").val(val);
			}else{
				let val = numberGuest($("#children").val(),true);
				$("#children").val(val);
			}
		});

		function numberGuest(guest,add){
			let result = 0;
			if(add){
				result = Number(guest) + 1;
			}else{
				result = Number(guest) - 1;
			}
			if(result < 0){
				result = 0
			}else if(result > 4){
				result = 4;
			}
			return result;
		}


		var start = $('#arriveInput').attr('value');
		var end = $('#departureInput').attr('value');
		var limitDate = $('#limitDate').attr('value').split(',');

		var opencheck = 0;
		var firstClick = 0;
		var opened = 0;
		
		//To create after event 
		$('#arriveInput').on('change', function () {
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		})
		$('#departureInput').on('change', function () {
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		})
		//alert($('#arriveInput').val());

		$('.calendar-block').datepicker({
			changeMonth: true,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 1,
			locale: {
				format:"M/D/YYYY",
				"monthNames": [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December"
				]
			},
			//altField: "#arriveInput",
			//altFormat: "mm-dd-yy",
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (firstClick == 0) {
					start = date;
					end = date;
					firstClick = 1;
				} else {
					if (selectedDate <= start) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					firstClick = 0;
				}
				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});


		$('.footer .signup-btn').appendTo('.footer .gdpr-wrap');

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
		// slick hover
		$(".slick-hover").mousemove(function (e) {
			if ((e.pageX - this.offsetLeft) < $(this).width() / 1.5) {
				$(this).remove('hover-right');
				$(this).addClass('hover-left');
			} else {
				$(this).removeClass('hover-left');
				$(this).addClass('hover-right');
			}
		});
		$(".slick-hover").on('click', function (e) {
			if ((e.pageX - this.offsetLeft) < $(this).width() / 1.5) {
				$(this).slick("slickPrev");
			} else {
				$(this).slick("slickNext");
			}
		});
		$('.slick-hover').mouseout(function () {
			$(this).removeClass('hover-right');
			$(this).removeClass('hover-left');
		})

		// $('.sym-counter').on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
		// 	//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		//  	var i = (nextSlide ? nextSlide : 0) + 1;
		//  	$('.pagingInfo').fadeOut(200, function(){
		// 		$(this).find('.slide-number').text(i);
		// 		$(this).find('.slide-total').text(slick.slideCount);
		// 		$(this).fadeIn(200);
		// 	});
		// });

		// $('.sym-counter').slick();

		//Aditional info rooms
		$('.js-more-details').on('click', function(e){
			e.preventDefault();
			$(this).parent().parent().find('.additional-info').addClass('open');
		})

		$('.js-close-info').on('click', function(e){
			e.preventDefault();
			$(this).parent().removeClass('open');
		})

		//Map Desktop
		$(".js-pin").click(function () {
			
			let selfPin = $(this);
			// This will have the category
			var theID = $(this).data("tag");
			tagLocation.push(theID);

			

			if(theID == 'all'){
				$(".js-pin").removeClass('active');
				$('.pin').addClass('active');
				tagLocation = [];
				$(this).addClass('active');
				
			} else {
				$(".js-pin").each(function(){
					if($(this).data("tag") === 'all'){
						$(this).removeClass('active');
					} 
				});
				selfPin.toggleClass('active');
				
				$('.pin').removeClass('active');
				for(let i = 0; i < tagLocation.length; i++){
					$('.pin[data-tag='+ tagLocation[i]+']').each(function(){
						if($(this).hasClass('active')){
							$(this).removeClass('active')
						} else {
							$(this).addClass('active')
						}
					});
				}
			}
			//console.log(tagLocation)
			

	
			
		});
		$('.pin').on('click', function(){
			$(this).addClass('open');
			$(this).siblings().removeClass('open');
			var pinId = $(this).attr('id');
			$('.'+pinId).addClass('active');
			$('.'+pinId).siblings().removeClass('active');
		})

		// Hover elements
		$('.js-h-item').on('click', function (e) {
			e.preventDefault();
			let self = $(this);
			
			$('.js-h-item').each(function(){
				$(this).removeClass('active');
			})
			$(this).addClass('active');
			var href = $(this).attr('data-target');
			$(href).addClass('active');
			$(href).siblings().removeClass('active');
		});

		//Accordion
		$(function() {
			// Cache selectors
			var $accordion = $(".js-accordion");
			var $allPanels = $(" .accordion-panel").hide();
			var $allItems = $(".accordion-item");
			var $internalTitle = $('.accordion-content h2');
		
			// Event listeners
			$accordion.on("click", ".accordion-toggle", function() {
				// Toggle the current accordion panel and close others
				$allPanels.slideUp();
				$allItems.removeClass("is-open");
				if (
					$(this).next().is(":visible")
				) {
					$(".accordion-panel").slideUp();
					$(this).find('.icon').html('Open +');
				} else {
					$(this).next().slideDown().closest(".accordion-item").addClass("is-open");
					$(this).find('.icon').html('Close -');
				}
				return false;
			});
			$internalTitle.next().slideUp();
			$internalTitle.on('click', function(){
				if ($(this).next().is(":visible")) {
					$(this).next().slideUp();
					$(this).removeClass('open');
				} else {
					$(this).next().slideDown();
					$(this).addClass('open');
				}
				return false;
			})
		});

		// Add smooth scrolling to all links
		$("a").on('click', function(event) {
			if(!".js-h-item"){
				// Make sure this.hash has a value before overriding default behavior
				if (this.hash !== "") {
				  // Prevent default anchor click behavior
				  event.preventDefault();
			
				  // Store hash
				  var hash = this.hash;
			
				  // Using jQuery's animate() method to add smooth page scroll
				  // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
				  $('html, body').animate({
					scrollTop: $(hash).offset().top
				  }, 800, function(){
			
					// Add hash (#) to URL when done scrolling (default click behavior)
					window.location.hash = hash;
				  });
				} // End if
			}

		});
		
		let jsForm = document.querySelector('.js-form');
		if (jsForm){
			jsForm.addEventListener('click', function(e){
				e.preventDefault();
				document.querySelector('.form-js').classList.add('open');
			})
		}
		


	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})

		let url = window.location.href;

		if(url.indexOf('#') > -1){
			let target = url.split('#')[1];
			animateTo(target);
		}



	};

	// Sign up form footer functionality

	let footerSignUp = document.querySelector('.footer__sign.content-signup');
	let signUpCta = document.querySelector('.signup-badge');
	
	footerSignUp.style.cursor = 'pointer';
	footerSignUp.addEventListener('click', () => simulateClick(signUpCta));

	function simulateClick(elem) {
		const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
		elem.dispatchEvent(event);
	}


}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}